module.exports = __webpack_public_path__ + "f108c981ed9611d5cc44f688b9ce80a4.svg";


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/app/scss/theme/font-open-sans/fonts/ExtraBold/OpenSans-ExtraBold.svg
// module id = 353
// module chunks = 0